import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { SubmitSurveyCommand } from "@shared-kernel/application/ports/student/student-repository";

export const submitSurvey = createAsyncThunk<void, SubmitSurveyCommand, { extra: Partial<Dependencies> }>(
  "student/submitSurvey",
  async (payload: SubmitSurveyCommand, { extra: { studentRepository } }) => {
    return studentRepository!.submitSurvey(payload);
  },
);
